module.exports = __webpack_public_path__ + "img/img-no-data.50d9f6cf.png";